export default "__VITE_ASSET__asWENeeZ__"